module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"myProfile":"ჩემი პროფილი","logout":"გამოსვლა","personal-info":"პირადი ინფორმაცია","contact-info":"საკონტაქტო ინფორმაცია","change-password":"პაროლის შეცვლა"}}')
  delete Component.options._Ctor
}
